customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    const sourceTemplate = document.getElementById('recently-viewed-products-template');
    const sourceElement = sourceTemplate?.content?.firstElementChild;
    if (!sourceElement) return;

    this.template = sourceElement.cloneNode(true);
    const track = this.template.querySelector('.gridy-track');
    this.slider = this.template.querySelector('gridy-slider');
    this.sliderArrows = this.template.querySelector('.gridy-arrows');
    if (!track || !this.slider || !this.sliderArrows) return;
    track.innerHTML = '';
    this.data_ipr_desktop = parseInt(this.slider.dataset.iprDesktop, 10) || 1;
    this.data_ipr_tablet = parseInt(this.slider.dataset.iprTablet, 10) || this.data_ipr_desktop;
    this.data_ipr_mobile = parseInt(this.slider.dataset.iprMobile, 10) || 1;

    this.limit = Number.parseInt(this.dataset.limit, 10) || 1;
    this.currentTemplate = this.dataset.currentTemplate;
    try {
      this.showAsThumbnails = this.dataset.showAsThumbnails != undefined
        ? JSON.parse(this.dataset.showAsThumbnails)
        : false;
    } catch (error) {
      this.showAsThumbnails = false;
    }

    // Section remains hidden if no history data found
    // History data is set from product-template.liquid
    let storedHistory = '';
    try {
      storedHistory = sessionStorage.getItem('Woolman_Product_History') || '';
    } catch (error) {
      storedHistory = '';
    }
    this.history = storedHistory.split(',').map((handle) => handle.trim()).filter(Boolean);

    // On product template needs to have more than 1 item since the current product is also included in the list of items
    if (this.currentTemplate === 'template-product' && this.history.length <= 1 || this.history.length === 0) {
      return;
    }

    this.fetchProductHtml();
  }

  /* This function fetches item HTML snippets and passes them to initContainer function */
  async fetchProductHtml() {

    const promises = [];
    const rootUrl = window.routes.root == '/' ? '/' : window.routes.root + '/'; // if user has selected locale convert root url from /en-gb to /en-gb/
    if (this.currentTemplate === 'template-product') {
      this.history.shift();
    }

    const historyToRender = this.history.slice(0, this.limit);

    const div = document.createElement("div");
    for (var i = 0; i < historyToRender.length; i++) {
      div.setAttribute('data-index', i);
      this.template.querySelector('.gridy-track').appendChild(div.cloneNode(true));
    }

    for (const productHandle of historyToRender) {
      let cardView = 'ajax-card';
      if (this.showAsThumbnails) {
        cardView = 'ajax-card-thumbnail';
      }
      promises.push(fetch(`${rootUrl}products/${productHandle}?view=${cardView}`));
    }

    let renderedCount = 0;
    const settledPromises = await Promise.allSettled(promises);
    const forEachPromises = settledPromises.map(async (promise, index) => {
      try {
        const res = await promise.value;
        if (!res.ok) {
          throw new Error(`Recently viewed product request failed with status ${res.status}`);
        }
        const htmlString = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const childToReplace = this.template.querySelector(`[data-index="${ index }"]`);
        const card = doc.body.firstElementChild;
        if (!childToReplace || !card) throw new Error('Recently viewed product response was empty');
        childToReplace.replaceWith(card);
        renderedCount++;
      } catch (err) {
        console.error(err);
        // You might want to handle errors within the forEach here
      }
    });

    // Use Promise.all to wait for all the forEachPromises to complete
    await Promise.all(forEachPromises).then(() => {
      this.template.querySelectorAll('[data-index]').forEach((placeholder) => placeholder.remove());
      if (renderedCount === 0) return;

      if (this.data_ipr_mobile >= renderedCount) {
        this.sliderArrows.classList.add('sm-down-hide');
      }
      if (this.data_ipr_tablet >= renderedCount) {
        this.sliderArrows.classList.add('sm-to-md-hide');
      }
      if (this.data_ipr_desktop >= renderedCount) {
        this.sliderArrows.classList.add('md-hide');
      }
      this.appendChild(this.template);
      this.removeAttribute('hidden');
    });
  }
})
